import Home from "./pages/Home";
import "normalize.css";
import { useEffect, useState } from "react";
import Question from "./pages/Question";
import Result from "./pages/Result";
import LifeStyle from "./pages/LifeStyle";

function App() {
  const DEFAULT_STATE = {
    page: "home",
    research: {
      proceed: 0,
      wholeProceed: 0,
      tie: false,
      result: false,
      step: "1",
      log: [],
      stepLog: [],
    }
  };
  const [state, setState] = useState(DEFAULT_STATE);

  const setDefault = () => {
    setState(DEFAULT_STATE);
  }

  const setPage = (value) => {
    const newState = {
      ...state,
      page: value,
    };
    setState(newState);
    window.history.pushState(newState, "");
  };

  const parseLog = (log) => {
    log = log.reduce((acc, curr) => {
      if (acc[curr.type]) {
        acc[curr.type] += 1;
      } else {
        acc[curr.type] = 1;
      }
      return acc;
    }, {});
    return log;
  }

  const goToNextStep = (value, question) => {
    const log = value.stepLog;
    const typeCount = parseLog(log);
    const max = Math.max(...Object.values(typeCount));
    const maxData = Object.keys(typeCount).filter(x => typeCount[x] === max);
    const isTie = maxData.length > 2;

    if (isTie) {
      goToNextQuestion(value);
    } else {
      const step = question.nextStep || maxData[0];
      if (step === "result") {
        const newState = {
          ...state,
          page: "result",
        }
        setState(newState);
        window.history.pushState(newState, "");
      } else {
        const newState = {
          ...state,
          research: {
            ...DEFAULT_STATE.research,
            result: question.result ? maxData[0] : false,
            step: step,
            wholeProceed: question.type === "tiebreaker" ? state.research.wholeProceed : state.research.wholeProceed + 1,
            log: value.log,
          },
        };
        setState(newState);
        window.history.pushState(newState, "");
      }
    }
  }

  const goToNextQuestion = (value) => {
    const newState = {
      ...state,
      research: value
    };
    setState(newState);
    window.history.pushState(newState, "");
  }

  const setResearch = (value, isLastOfStep, question) => {
    if (isLastOfStep) {
      goToNextStep(value, question);
    } else {
      goToNextQuestion(value, question);
    }
  };

  useEffect(() => {
    window.history.pushState(DEFAULT_STATE, "");
    window.onpopstate = () => {
      setState(window.history.state || DEFAULT_STATE);
    }
  }, []);


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [state.page, state.research.proceed]);

  const { page, research } = state;

  switch (page) {
    case "lifestyle":
      return <LifeStyle resultNum={research.result} setPage={setPage} />
    case "result":
      return <Result resultNum={research.result} setPage={setPage} />;
    case "question":
      return <Question
        setAnswer={(answerElement, isLastOfStep, isTieBreaker, question) => {
          const wholeProceed = research.wholeProceed;
          setResearch({
            ...research,
            proceed: research.proceed + 1,
            wholeProceed: (isTieBreaker ? wholeProceed : wholeProceed + 1),
            log: [
              ...research.log,
              answerElement
            ],
            stepLog: [
              ...research.stepLog,
              answerElement
            ]
          }, isLastOfStep, question);
        }}
        tie={research.tie}
        step={research.step}
        proceed={research.proceed}
        wholeProceed={research.wholeProceed}
        setDefault={setDefault}
      />
    default:
      return (
        <Home setPage={setPage} />
      );
  }

}

export default App;